var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-button',{attrs:{"theme":_vm.theme,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[(_vm.icon)?_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }